import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Element, scroller} from 'react-scroll';
import CardList from './CardList';
import {Route} from "react-router";
import {addCards, putCards, retrieveCards} from "../../store/cards/actions";
import CardAddBar from './CardAddBar';
import {getObjectById} from "utils";
import {retrieveDifficulties} from "../../store/difficulties/actions";
import {translate} from "react-i18next";
import PackageDetailTitle from './PackageDetailTitle'
import PackageDetailToolbar from './PackageDetailToolbar'
import MassImportDialog from './mass_import/MassImportDialog'
import {setLocalIncrement, retrieveMe} from '../../store/auth/actions'
import {reset} from 'redux-form'


class PackageDetailPage extends Component {

    constructor() {
        super();
        this.state = {
            'isImportDialogOpened': false,
            'initImportGrid': []
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    scrollToCard = (card) => {
        setTimeout(function () { // element is not in dom immediately
            scroller.scrollTo('card-' + card.id, {smooth: false, offset: -100});
        }, 250);
    };

    handleImportDialog = () => {
        this.props.resetCardForm()
        this.setState({isImportDialogOpened: !this.state.isImportDialogOpened, initImportGrid: []})

    }

    onCardFieldPaste = (e) => {
        const clipboardData = e.clipboardData.getData('text/plain')
        const fixGrid = (data) => {
            let finalGrid = [];
            if (data.length) {
                for (let i = 0; i < data.length; i++) {
                    const row = data[i]
                    if (row.length >= 2) {
                        let finalRow = [
                            {value: ''},
                            {value: ''},
                            {value: ''}
                        ]
                        finalRow[0]['value'] = row[0]
                        finalRow[1]['value'] = row[1]
                        if (row.length >= 3) {
                            finalRow[2]['value'] = row[2]
                        }
                        finalGrid.push(finalRow)
                    }
                }
            }
            return finalGrid
        }

        const parsedGrid = fixGrid(clipboardData.split(/\r\n|\n|\r/).map((row) => row.split('\t')))

        if (parsedGrid.length > 0) {
            this.setState({
                initImportGrid: parsedGrid,
                isImportDialogOpened: true,
            })

        }
    }

    render() {
        var pckg = this.props.packages.filter(x => (x.slug === this.props.match.params.packageSlug))[0];
        if(!pckg){
            //try to find it by old way - by id
            // TODo: resolve in the future
            pckg = this.props.packages.filter(x => (x.id === parseInt(this.props.match.params.packageSlug, 10)))[0];
        }
        if (!pckg) {
            const url = process.env.REACT_APP_WEB_BASE_URL + 'package/' + this.props.match.params.packageSlug;
            return <Route path='/' component={() => {
                window.location.href = url;
                return null;
            }}/>
        }
        const cards = this.props.cards.filter(c => c.package_id === pckg.id);
        const nativeLang = getObjectById(this.props.langs, pckg.native_language);
        const foreignLang = getObjectById(this.props.langs, pckg.foreign_language);
        return (
            <div className="section" style={{marginTop: '20px'}}>
                <div style={{overflow: 'auto'}}>
                    <PackageDetailTitle title={pckg.name}/>
                    <PackageDetailToolbar me={this.props.auth.me} pckg={pckg} cards={cards} nativeLang={nativeLang} foreignLang={foreignLang} onImportBtnClick={this.handleImportDialog}/>
                </div>
                <CardList cards={cards} nativeLang={nativeLang} foreignLang={foreignLang}/>
                <Element name="end-of-card-list" className="element"/>
                <CardAddBar
                    onFirstFieldPaste={this.onCardFieldPaste}
                    cards={cards}
                    package={pckg}
                    onCardAdded={this.scrollToCard}
                    nativeLang={nativeLang}
                    foreignLang={foreignLang}
                />
                {this.state.isImportDialogOpened ?
                    <MassImportDialog
                        initGrid={this.state.initImportGrid}
                        onClose={this.handleImportDialog}
                        addCards={this.props.addCards}
                        setLocalIncrement={this.props.setLocalIncrement}
                        auth={this.props.auth}
                        open={this.state.isImportDialogOpened}
                        package={pckg}
                        nativeLang={nativeLang}
                        foreignLang={foreignLang}
                    /> : null
                }
            </div>
        )
    }
}


const
    mapStateToProps = (state) => {
        return {
            packages: state.package.items,
            cards: state.card.items,
            langs: state.lang.languages,
            auth: state.auth
        }
    };

const
    mapDispatchToProps = (dispatch, ownProps) => {
        return {
            onMount: () => {
                dispatch(retrieveDifficulties());
                dispatch(retrieveCards());
                dispatch(retrieveMe());
            },
            addCards: (cards) => {
                dispatch(addCards(cards))
                dispatch(putCards())
            },
            setLocalIncrement: (value) => {
                dispatch(setLocalIncrement(value))
            },
            resetCardForm: () => {
                dispatch(reset('cardForm'))
            }
        }
    };

export default connect(mapStateToProps, mapDispatchToProps)

(
    translate()

    (
        PackageDetailPage
    ))
;



// WEBPACK FOOTER //
// ./src/components/packages/PackageDetailPage.js